import { render, staticRenderFns } from "./teamFitRefName.vue?vue&type=template&id=b3af80a2&scoped=true&"
import script from "./teamFitRefName.vue?vue&type=script&lang=js&"
export * from "./teamFitRefName.vue?vue&type=script&lang=js&"
import style0 from "./teamFitRefName.vue?vue&type=style&index=0&id=b3af80a2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b3af80a2",
  null
  
)

export default component.exports